import ApiDrivenModel from "../../../../models/ApiDrivenModel";

export default class SaleReport extends ApiDrivenModel {
}
SaleReport.ENDPOINT = "/Sale_Report";
